<template>
  <div class="min-h-view h-view flex flex-col overflow-auto">
    <div class="flex grow flex-row flex-wrap items-center justify-center gap-8 self-center p-8">
      <h2
        v-if="noSeminars"
        class="flex max-w-(--breakpoint-xl) flex-col items-center justify-center p-8 text-center text-2xl"
      >
        Seminar-lista har ikke blitt sluppet for UL enda, men sjekk tilbake senere!
      </h2>
      <img
        v-for="seminar in seminars"
        :key="seminar.id"
        :src="seminar.image"
        :alt="getSeminarAlt(seminar)"
        class="w-64 cursor-pointer hover:scale-105 xl:w-84"
        @click="openSeminar(seminar)"
      />
    </div>

    <Dialog
      v-if="selectedSeminar"
      @close="selectedSeminar = null"
      class="relative grid max-h-3/4 w-3/4 max-w-3/4 max-sm:overflow-auto sm:aspect-video sm:grid-cols-2"
    >
      <img
        :src="selectedSeminar.image"
        :alt="getSeminarAlt(selectedSeminar)"
        class="hidden h-full object-cover sm:block"
      />
      <button
        @click="selectedSeminar = null"
        class="hover:text-opacity-50 absolute top-2 right-2 flex h-8 w-8 items-center justify-center rounded-full bg-black text-center text-xl text-white opacity-10 hover:opacity-20"
      >
        &times;
      </button>
      <div class="bg-ul-orange-400 flex max-h-full flex-col gap-4 text-center sm:overflow-auto sm:bg-white">
        <div class="w-full p-4">
          <h2 class="text-ul-orange-400 bg-ul-orange-100 p-4 text-4xl sm:hidden">
            {{ selectedSeminar.speaker }}
          </h2>
          <h1 class="text-ul-orange-100 mb-4 p-4 text-4xl sm:hidden">
            {{ selectedSeminar.title }}
          </h1>
          <p class="bg-ul-orange-100 w-full p-4 text-left whitespace-pre-line text-black sm:bg-white">
            {{ selectedSeminar.description }}
          </p>
        </div>
      </div>
    </Dialog>

    <PageFooter />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import Dialog from '../components/Dialog.vue'
import PageFooter from '../components/PageFooter.vue'
import { useSeminarStore } from '../stores/seminars'
import type { Seminar } from '../types'

const seminarStore = useSeminarStore()
const seminars = seminarStore.seminars.toSorted((a, b) =>
  a.title.toLocaleLowerCase() > b.title.toLocaleLowerCase() ? 1 : -1
)

const noSeminars = seminars.length === 0

function getSeminarAlt(seminar: Seminar) {
  return `${seminar.speaker} - ${seminar.title}`
}

const selectedSeminar = ref<Seminar | null>(null)

function openSeminar(seminar: Seminar) {
  selectedSeminar.value = seminar
}
</script>

<style lang="scss"></style>
